import Localization from '~/client/src/shared/localization/LocalizationManager'

export function getResourcePlaceholderText(
  allowSelectExisting = true,
  allowCreateNew = true,
): string {
  if (allowSelectExisting && allowCreateNew) {
    return `${Localization.translator.select} ${Localization.translator.or} ${Localization.translator.createNew}`
  }
  if (allowCreateNew && !allowSelectExisting) {
    return Localization.translator.createNew
  }
  return Localization.translator.select
}
